import React, { useContext } from "react";
import { OnpContext } from "./OnpLayout";
import { useHistory, useLocation, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { notifyError, onpRequest } from "../../util";
import { CircularProgress, Grid } from "@mui/material";
import QRCode from "react-qr-code";
import { translate } from "../../i18n/customI18nProvider";
import TwintToken from "../../components/twint/TwintToken";
import PaymentSuccess from "./SuccessAlert";
import { OrdersStorage } from "./OnpLocalStorage";
import { computeTotal } from "./utils";
import { translates } from "../../i18n/customI18nProvider";

let ordersStorage = null;
export default function PayrexxPayment({method = 'twint'}) {
    const history = useHistory();
    const location = useLocation();
    const { userName, success, uid } = Object.fromEntries(new URLSearchParams(location.search));
    const { barId, table_number } = useParams();
    const { barInfo, order, consumptionChange, clearOrder, getConsumptionQuantity, getConsumptions, maxWidth, navigate } = useContext(OnpContext) || { barInfo: { consumptions: [] } };

    const [loading, setLoading] = React.useState(true);
    const [status, setStatus] = React.useState(null);

    const apiError = async (message) => {
        notifyError(message);
        navigate('/onp/' + barId + '/' + table_number + '/cart');
    }

    const twintCheckin = async (uid) => {
        try {
            const payload = {
                amount: computeTotal(order, barInfo),
                url: window.location.origin + '/onp/' + barId + '/' + table_number + '/twint?success=true&uid=' + uid
            }
            const response = await onpRequest(barId, '/pwl/' + uid + '/payrexx/pay', 'POST', null, payload);
            if(!response.link) {
                apiError(translate("custom.error_initializing_payment"));
                return;
            }
            window.location.href = response.link;
        } catch (error) {
            apiError(translate("custom.error_initializing_payment"));
        }
    }

    const initPayment = async () => {
        if(!userName) {
            apiError(translate("custom.client_name_missing"));
            return;
        }
        const payload = {
            method: method,
            order: order.map(item => ({ id: item.id, quantity: item.quantity })),
            table_number: table_number,
            client_name: userName,
            amount_precalculated: computeTotal(order, barInfo)
        }
        try {
            const response = await onpRequest(barId, '/pay', 'POST', null, payload);
            if(response.status !== 'initiated') {
                if(response.error) {
                    apiError(response.error);
                } else {
                    apiError(translate("custom.error_initializing_payment"));
                }
            } else {
                ordersStorage.addPendingOrder({barId: barId, pwlUid: response.pollWaitList.uid});
                twintCheckin(response.pollWaitList.uid);
            }
        } catch (error) {
            apiError(translate("custom.error_initializing_payment"));
        }   
    }

    const navigateToOrder = () => {
        navigate('/onp/' + barId + '/' + table_number + '/orders');
    }

    const checkPaymentStatus = async (uid) => {
        if(!uid) return;
        const response = await onpRequest(barId, '/pwl/' + uid + '/status');
        if(!response.status) return;
        if(response.status === 'pending') {
            setTimeout(() => checkPaymentStatus(uid), 1000);
        } else {
            if(response.status === 'success') {
                setLoading(false);
                setStatus('success');
                clearOrder();
                const client = response.client;
                let transaction = null;
                for(const t of client.transactions) {
                    if(t.type == "debit") {
                        transaction = t;
                    }
                }
                const orderData = {
                    uid: client.uid,
                    number: transaction.order_number,
                    total: transaction.amount,
                    createdAt: transaction.date
                }
                ordersStorage.addOrder(orderData);
                ordersStorage.removePendingOrderWithPwlUid(uid);
            } else {
                apiError(translate("custom.payment_failed_onp"));
            }
        }
    }
    
    React.useEffect(() => {
        if(!barInfo.eventId) return;
        ordersStorage = new OrdersStorage(barInfo.eventId);

        if(success && status !== 'success') {
            checkPaymentStatus(uid);
        } else if(order.length > 0) {
            initPayment();
        } else {
            if(status !== 'success') {
                apiError(translate("custom.your_cart_is_empty"));
            }
        }
    }, [order.length, success, userName, barInfo.eventId]);

    const render = () => {
        if(loading) {
            return (
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 50}}>
                    <CircularProgress />
                </div>
            )
        }

        if(status === 'success') {
            return (
                <PaymentSuccess onClose={navigateToOrder} />
            )
        }
    }
    
    return (
        <div style={{marginBottom: 80}}>
            {render()}
        </div>
    )
}